import { render, staticRenderFns } from "./IconCircleX.vue?vue&type=template&id=725d3a16"
import script from "./IconCircleX.vue?vue&type=script&lang=js"
export * from "./IconCircleX.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports